import {useGet, useQueryWithErrorHandling,} from '@app/sdk';

export function useAccessPayConfiguration() {
  const get = useGet(true, "rp");

  async function getAccessPayConfig() {
    return await get<any>(
      `/api/proxy/rp/scheme-integration-service/debug/externalConfiguration`,
      {}
    );
  }

  return useQueryWithErrorHandling({
    queryKey: ["access-pay-config"],
    queryFn: getAccessPayConfig
  });
}
